<div class="modal-container">
  <div class="modal-header">
    <div class="modal-title-wrap">
      <h3 id="validaitor-upload-dialog-title">Upload to ValidAItor</h3>
      <p>
        {{ files().length }} {{ files().length === 1 ? 'file' : 'files' }} selected.
        Choose a destination folder, then upload.
      </p>
    </div>
    <button type="button" class="modal-close" aria-label="Close" (click)="close()">
      <span class="material-icons" translate="no">close</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-field-container">
      <label class="form-field-label" for="validator-folder-select">Destination folder</label>
      @if (foldersLoading()) {
        <p class="status-line">Loading folders…</p>
      } @else if (folders().length === 0) {
        <p class="status-line">No ValidAItor folders yet. Create a folder in ValidAItor first, then upload here.</p>
      } @else {
        <ng-select
          id="validator-folder-select"
          class="ng-select veeva-ng-select"
          [items]="folders()"
          bindLabel="title"
          bindValue="_id"
          [ngModel]="selectedFolderId()"
          (ngModelChange)="onFolderChange($event)"
          placeholder="Choose a folder"
          notFoundText="No matching folders"
          [loading]="foldersLoading()"
          [clearable]="false"
          [searchable]="true"
          [disabled]="isUploading()"
          appendTo="body"
          dropdownPosition="auto"
        ></ng-select>
      }
    </div>

    @if (hasPdfFiles()) {
      <div class="form-field-container">
        <label class="form-field-label" for="validator-pipeline-select">PDF processing pipeline</label>
        <ng-select
          id="validator-pipeline-select"
          class="ng-select veeva-ng-select"
          [items]="pipelineOptions"
          bindLabel="label"
          bindValue="value"
          [ngModel]="pipeline()"
          (ngModelChange)="pipeline.set($event)"
          [clearable]="false"
          [searchable]="false"
          [disabled]="isUploading()"
          appendTo="body"
          dropdownPosition="auto"
        >
          <ng-template ng-option-tmp let-item="item">
            <div class="pipeline-option">
              <span class="pipeline-option-label">{{ item.label }}</span>
              <span class="pipeline-option-description">{{ item.description }}</span>
            </div>
          </ng-template>
        </ng-select>
        <p class="form-field-hint">Applies to PDF files only; other file types are processed normally.</p>
      </div>
    }

    @if (uploadedCount() > 0 || failedFiles().length > 0) {
      <section class="upload-summary" role="status" aria-live="polite">
        @if (uploadedCount() > 0) {
          <p>{{ uploadedCount() }} {{ uploadedCount() === 1 ? 'document' : 'documents' }} uploaded successfully.</p>
        }
        @if (failedFiles().length > 0) {
          <p>{{ failedFiles().length }} {{ failedFiles().length === 1 ? 'file' : 'files' }} failed.</p>
          <ul>
            @for (file of failedFiles(); track file.name + file.size) {
              <li>{{ file.name }}</li>
            }
          </ul>
        }
      </section>
    }
  </div>

  <div class="modal-footer">
    <button mat-stroked-button type="button" class="action-btn" (click)="close()">Cancel</button>
    @if (uploadedCount() > 0 && failedFiles().length > 0) {
      <button mat-stroked-button type="button" class="action-btn" (click)="closeWithUploadedFiles()">Go to folder</button>
    }
    @if (failedFiles().length > 0) {
      <button
        mat-raised-button
        color="accent"
        type="button"
        class="action-btn"
        [disabled]="isUploading()"
        (click)="uploadFiles(failedFiles())"
      >
        Retry failed files
      </button>
    } @else {
      <button
        mat-raised-button
        color="accent"
        type="button"
        class="action-btn"
        [disabled]="!canUpload()"
        (click)="uploadFiles()"
      >
        {{ uploadButtonLabel() }}
      </button>
    }
  </div>
</div>
